export default {"src":"/uk/_next/static/media/darkGreyInfoIcon.68e248ce.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};